import type { ModalProps } from '@mantine/core'

/**
 * A plain fade for modals with `position: fixed` or viewport-sized children: the default fade-down
 * leaves a transform on the content, which becomes their containing block and scrolls the footer away.
 */
export const FIXED_CHILDREN_MODAL_TRANSITION: ModalProps['transitionProps'] = {
  transition: 'fade',
  duration: 200,
}
